import api from '../api'; 
import { API_URL } from '../config';

// Get all registered API endpoints
export const getAllEndpoints = async () => {
  const res = await api.get(`${API_URL}/all-endpoints`);
  return res.data;
};

// Get all endpoints with @PreAuthorize annotations
export const getEndpointsWithPreAuthorize = async () => {
  const res = await api.get(`${API_URL}/endpoints-with-preauthorize`);
  return res.data;
};

// Get security mappings
export const getSecurityMappings = async () => {
  const res = await api.get(`${API_URL}/security-mapping`);
  return res.data;
};

// Get endpoints with role information
export const getEndpointsWithRoles = async () => {
  const res = await api.get(`${API_URL}/endpoints-with-roles`);
  return res.data;
};